exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-f3fb9d0e]{position:fixed;top:0;bottom:0;right:0;left:0;z-index:1000001;background:#131313;color:#ddd;display:flex;justify-content:center;align-items:center}.overlay .overlay-content[data-v-f3fb9d0e]{font-size:1.5rem;letter-spacing:1px;padding:1.5rem 2rem;border:2px solid #7a7a7a;border-radius:3px}.overlay .overlay-content .flex[data-v-f3fb9d0e]:first-child{margin-bottom:1rem}.overlay .overlay-content .flex b[data-v-f3fb9d0e]{width:250px}", ""]);

// exports
